/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_Q7Inputs */

const en_csv_to_json_faq_q7 = /** @type {(inputs: Csv_To_Json_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens if two columns have the same header?`)
};

const ko_csv_to_json_faq_q7 = /** @type {(inputs: Csv_To_Json_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 열의 헤더가 같으면 어떻게 되나요?`)
};

const ja_csv_to_json_faq_q7 = /** @type {(inputs: Csv_To_Json_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 つの列のヘッダが同じ場合はどうなりますか`)
};

/**
* | output |
* | --- |
* | "What happens if two columns have the same header?" |
*
* @param {Csv_To_Json_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_q7 = /** @type {((inputs?: Csv_To_Json_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_q7(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_q7(inputs)
	return ja_csv_to_json_faq_q7(inputs)
});